module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout"
  }, [_c('div', {
    ref: "layoutWrap",
    staticClass: "layout-wrap"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._t("page-title")], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._t("left")], 2), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "center-top"
  }, [_vm._t("center-top")], 2), _vm._v(" "), _c('div', {
    staticClass: "center-bottom"
  }, [_c('div', {
    staticClass: "center-bottom-left"
  }, [_vm._t("center-bottom-left")], 2), _vm._v(" "), _c('div', {
    staticClass: "center-bottom-right"
  }, [_vm._t("center-bottom-right")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("right")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_vm._t("page-footer")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-779ed77a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/page-layout/index.vue
// module id = 240
// module chunks = 0